<ng-container *ngIf="item?.children?.length > 0">
  <a
    *ngIf="validateAccessMenu(item) && nivel !== 0"
    class="nav-link dir-menu-govco cursor-pointer d-none d-lg-flex active"
    [routerLink]="item?.routerLink"
    [queryParams]="{ rep: item?.queryParams }"
    (click)="itemSeleccionadoReporte(item?.id, false)"
    [ngClass]="['nivel' + nivel, returnClassList(item)]"
    aria-current="page"
  >
    <span class="text-item-menu-govco">
      {{ item?.nombre }}
    </span>
  </a>
  <app-menu-dropdown
    [ngClass]="{ 'd-block d-lg-none': nivel !== 0 }"
    [item]="item"
    [rolesUsuario]="rolesUsuario"
    [nivel]="nivel"
    (cerrarMenu)="cerrarMenuEvt()"
  ></app-menu-dropdown>
</ng-container>

<ng-container *ngIf="item?.children?.length == 0 || !item?.children">
  <a
    *ngIf="validateAccessMenu(item)"
    class="nav-link dir-menu-govco cursor-pointer d-flex"
    [routerLink]="item.routerLink"
    [queryParams]="{ rep: item.queryParams }"
    (click)="itemSeleccionadoReporte2(item?.id, false)"
    [ngClass]="['nivel' + nivel, returnClassList(item)]"
    aria-current="page"
  >
    <span class="text-item-menu-govco">
      {{ item?.nombre }}
    </span>
  </a>
</ng-container>
